import React from "react";
import {Heart, House, Map, MessageCircleQuestionMark, Star} from "lucide-react";
import './FooterNav.css';

export default function FooterNav({ page, setPage }) {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#fff",
        borderTop: "1px solid #ccc",
        display: "flex",
        justifyContent: "space-around",
        padding: "10px 0",
        zIndex: 99
      }}
    >
      <button onClick={() => setPage("home")} className={`footer-nav-button ${ (page === 'home') ? 'footer-nav-button-active' : ''}`}>
          <House />
          <span style={{ marginTop: '8px'}}>Главная</span>
      </button>
      <button onClick={() => setPage("favorites")} className={`footer-nav-button ${ (page === 'favorites') ? 'footer-nav-button-active' : ''}`}>
          <Heart />
          <span style={{ marginTop: '8px'}}>Избранное</span>
      </button>

      {/* ВАЖНО: теперь открывает страницу адресов */}
      <button onClick={() => setPage("addresses")} className={`footer-nav-button ${ (page === 'addresses') ? 'footer-nav-button-active' : ''}`}>
          <Map />
          <span style={{ marginTop: '8px'}}>Адреса</span>
      </button>

      <button onClick={() => setPage("about")} className={`footer-nav-button ${ (page === 'about') ? 'footer-nav-button-active' : ''}`}>
          <MessageCircleQuestionMark />
          <span style={{ marginTop: '8px'}}>О нас</span>
      </button>
    </div>
  );
}

const btnStyle = {

};
